// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import grey from "@material-ui/core/colors/grey"

// FLASH
import FlashLogo from "../static/images/lightning-logo-transparent.png"

const styles = theme => ({
    appbarRoot: {
        height: 50
    },

    appbarMessage: {
        padding: 8,
    },

    appheadRoot: {
        height: 50,
        marginTop: 50,
        background: grey[270],
        border: "none",
        boxShadow: "none",
        zIndex: 0,
    },

    bnavbarRoot: {
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: grey[300],
    },

    
    appheadMessage: {
        padding: 8,
        width: "100%",
        textAlign: "center",
        fontWeight: 600,
    },

    contentDiv: {
        padding: 0,
        marginTop: 60,
        marginBottom: 50,
    },

    profileButton: {
        margin: 20,
        padding: 8,
        width: 200,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    continueButton: {
        margin: 20,
        padding: 8,
        width: 200,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    welcomeMessage: {
        marginTop: 20,
        // mobile
        // fontSize is working
        [theme.breakpoints.down("sm")]: {
            fontSize: 30,
        },
    },

    mobileAppIcon: {
        display: "none", // show only in mobile
        [theme.breakpoints.down("sm")]: {
            display: "block",
            margin: "0 auto",
            paddingTop: 30,
        },
    },

    logoutDiv: {
        position: "fixed",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center
    },

    animationDiv: {
        display: "flex",
        flexDirection: "column",
        
        width: 300,
        height: 300,
//        backgroundColor: green[100],

        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        animationName: "$logoutAnimation",
        animationDuration: "2s",
        animationFillMode: "forwards",

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            animationName: "$logoutAnimationDesktop",
        },
    },

    "@keyframes logoutAnimation":  {
        "0%": {
            opacity: 0,
            fontSize: 12,
            height: 200,
            width: 200,
        },

        // fade in so that icon does not "blink"
        "10%": {
            opacity: 0.5,
            fontSize: 12,
            height: 200,
            width: 200,
        },
       
        "100%": {
            opacity: 1,
            fontSize: 20,
            height: 400,
            width: 400,
        },

    },

    //
    // desktop
    //
  "@keyframes logoutAnimationDesktop":  {
      "0%": {
          opacity: 0, 
          fontSize: 15,
          height: 300,
          width: 300,
      },

      "1%": {
          opacity: 0.2,
          fontSize: 15,
          height: 300,
          width: 300,
      },
      
      "100%": {
          opacity: 1,
          marginTop: 0,
          fontSize: 30,
          height: 500,
          width: 500,
      },

    },
    
})

class Logout extends Component {

    state = {
        redirectBack: false,
        redirectContinue: false,
        redirectToIssues: false,
    }

    handleCloseClick = () => {
        console.log("<Logout>: handleCloseClick()")
        this.setState({redirectLogout: true})
    }

    handleIssueClick = () => {
        console.log("<Logout>: handleIssueClick()")
        this.setState({redirectToIssues: true})
    }

    
    handleProfileClick = () => {
        console.log("<Logout>: handleProfileClick()")
        this.setState({redirectToProfile: true})
    }

    handleContinueClick = () => {
        console.log("<Logout>: handleContinueClick()")
        this.setState({redirectToContacts: true})
    }
    
    render() {
        const { classes } = this.props

        // redirects first
        if (this.state.redirectBack) {
            return <Redirect push to="/summary"/>
        } else if(this.state.redirectLogout) {
            return <Redirect push to="/logout"/>
        } else if(this.state.redirectToIssues) {
            return <Redirect push to="/issues"/>
        }
        
	return(
            <React.Fragment>
	      <CssBaseline/>
              {
                  //
                  // Main content
                  //
              }
              <div className={classes.contentDiv}>
                <div className={classes.logoutDiv}>
                  <div className={classes.animationDiv}>
                    <div style={{position: "relative", width: "100%", height: "50%", textAlign: "center"}}>
                      {/* put this puppy on the bottom and in the center */}
                      <div style={{position: "absolute", bottom: 0, marginLeft: "auto", marginRight: "auto", left: 0, right: 0}}>
                        <img alt="logo" src={FlashLogo} style={{width: "40%"}}/>
                      </div>            
                    </div>            
                    <div style={{width: "100%", height: "50%", textAlign: "center"}}>
                      You'll be heard and have an impact!
                    </div>            
                  </div>
                </div>
              </div>

            </React.Fragment>
	)
    }
}

Logout.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "Logout" })(Logout)

